import './report-menu.scss'

import { faCheck, faTimes, faExclamationTriangle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import { OfflineDataFetcher } from '@skinsoft/offline'
import { ConditionReportDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'
import { router, Routes } from '../../../router'
import {
    DELETE_CURRENT_REPORT_TOPIC,
    OPEN_CLOSE_REPORT_SCREEN_TOPIC,
    OPEN_PDF_OVERVIEW_TOPIC,
    OPEN_SIGNATURE_MODULE_TOPIC,
    SAVE_CURRENT_REPORT_TOPIC,
    DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC,
    DUPLICATE_CLOSED_REPORT_TOPIC,
    OPEN_COUNTER_SIGNATURE_MODULE_TOPIC,
} from '../../../busTopics'

@Component({
    template: require('./report-menu.html'),
    props: ['reportId', 'readOnly'],
})
export class ReportMenu extends ReactiveVue {
    @Prop({ default: null })
    public reportId: string | null

    private isConfirmationDeleteReportVisible = false
    private isConfirmationDeleteUnsyncModifVisible = false
    private canEdit = true

    // Icons
    private crossIcon = faTimes
    private checkIcon = faCheck
    private warningIcon = faExclamationTriangle
    private loadingIcon = faCircleNotch

    private $conditionReportDataStore: ConditionReportDataStore

    // Used to react to network connection changes
    private isOnline = window.navigator.onLine
    private reportHasCachedUpdate = false

    public created() {
        window.addEventListener('offline', this.onConnectivityChange)
        window.addEventListener('online', this.onConnectivityChange)
        
        this.subscribeToBus(IMAGE_UPLOADED_TOPIC, this.onMediaStartLoading)
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, this.onMediaEndLoading)

        this.checkCachedUpdates()
    }

    public destroyed() {
        window.removeEventListener('offline', this.onConnectivityChange)
        window.removeEventListener('online', this.onConnectivityChange)
    }

    private onConnectivityChange() {
        this.isOnline = window.navigator.onLine
    }

    public get isDeleteAllowed() {
        if (this.reportId === null) {
            return false
        }

        return this.isOnline || OfflineDataFetcher.isTemporaryId(this.reportId)
    }

    public get isNewReportNotSynchronized() {
        if(this.reportId) {
            return OfflineDataFetcher.isTemporaryId(this.reportId)
        }
        
        return false
    }

    public async checkCachedUpdates() {
        if(this.reportId) {
            this.reportHasCachedUpdate = await this.$conditionReportDataStore.hasCachedUpdates(this.reportId)
        }
    }

    public saveReport() {
        if(this.canEdit) {
            this.emitOnBus(SAVE_CURRENT_REPORT_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        }
    }

    public deleteModificationsNotSynchronized() {
        this.emitOnBus(DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC)
    }

    public openReportOverview() {
        this.emitOnBus(OPEN_PDF_OVERVIEW_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC)
    }

    public openSignatureModule() {
        this.emitOnBus(OPEN_SIGNATURE_MODULE_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC)
    }

    public openCounterSignatureModule() {
        this.emitOnBus(OPEN_COUNTER_SIGNATURE_MODULE_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC)
    }

    public openCloseModuleScreen() {
        this.emitOnBus(OPEN_CLOSE_REPORT_SCREEN_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC)
    }

    public showDeleteConfirmation(value: boolean) {
        this.isConfirmationDeleteReportVisible = value
    }

    public showDeleteUnsyncModifConfirmation(value: boolean) {
        this.isConfirmationDeleteUnsyncModifVisible = value
    }

    public deleteReport() {
        this.emitOnBus(TOGGLE_MENU_TOPIC)
        this.emitOnBus(DELETE_CURRENT_REPORT_TOPIC)
        router.push({ name: Routes.CONDITION_REPORT_HOME })
    }

    public duplicateClosedReport() {
        this.emitOnBus(TOGGLE_MENU_TOPIC)
        this.emitOnBus(DUPLICATE_CLOSED_REPORT_TOPIC)
    }

    public onMediaStartLoading() {
        this.canEdit = false
    }

    public onMediaEndLoading() {
        this.canEdit = true
    }

    @Watch('reportId')
    public onReportIdChanged() {
        this.checkCachedUpdates()
    }
}
